
export const CHAT_TAIL_LIFETIME_MS = 5_000;

export const CHAT_TAIL_NAME_LIFT_PX = 17;

export const CHAT_TAIL_COLOUR = "#ffffff";

interface Tail {
  readonly text: string;
  /** Wall-clock ms, `CTimer::GetCurrentMillisecond() + TextTail_GetLivingTime()`
   *  (`UserInterface/PythonTextTail.cpp:611`). */
  readonly livingTimeMs: number;
}

/** One live chat tail per speaker, exactly as `m_ChatTailMap` holds them
 *  (`UserInterface/PythonTextTail.h:106`, a `std::map<DWORD, TTextTail*>`). */
export class ChatTails {
  private readonly tails = new Map<number, Tail>();

  constructor(private readonly now: () => number = () => Date.now()) {}

  register(entityId: number, text: string): void {
    if (entityId === 0) return;
    const nowMs = this.now();
    this.prune(nowMs);
    this.tails.set(entityId, { text, livingTimeMs: nowMs + CHAT_TAIL_LIFETIME_MS });
  }

  /** The line over this speaker's head right now, or null. */
  textFor(entityId: number): string | null {
    const tail = this.tails.get(entityId);
    if (tail === undefined) return null;
    if (this.expired(tail, this.now())) {
      this.tails.delete(entityId);
      return null;
    }
    return tail.text;
  }

  /** `CPythonTextTail::Clear` (`UserInterface/PythonTextTail.cpp:1008-1016`). */
  clear(): void {
    this.tails.clear();
  }

  delete(entityId: number): void {
    this.tails.delete(entityId);
  }

  /** Live tails, for a test that wants to see the map is bounded. */
  get size(): number {
    return this.tails.size;
  }

  private expired(tail: Tail, nowMs: number): boolean {
    return tail.livingTimeMs < nowMs;
  }

  private prune(nowMs: number): void {
    for (const [id, tail] of this.tails) {
      if (this.expired(tail, nowMs)) this.tails.delete(id);
    }
  }
}

/** The one registry the network phase writes and the render pass reads --
 *  `CPythonTextTail::Instance()`'s role, and nothing more than that. */
export const chatTails = new ChatTails();
